var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"HomeHionAdm"},[_c('PageTitle',{attrs:{"icon":"fas fa-user-lock iconInterativoTitulo","main":"PLATAFORMA ADMINISTRATIVA HION","sub":"Dashboard Interativo"}}),_c('hr',{staticClass:"ml-2 mr-2"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }